import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M8.36 2.767C8.645 2.255 8.787 2 9 2s.355.255.64.767l.074.132c.081.146.121.218.184.266.064.048.143.066.3.101l.143.033c.554.125.83.188.896.399s-.123.433-.5.874l-.098.114c-.107.125-.16.187-.185.265s-.016.162 0 .329l.015.152c.057.589.086.883-.086 1.014s-.432.011-.95-.227l-.134-.062c-.147-.067-.221-.102-.299-.102s-.152.035-.3.102l-.133.062c-.518.238-.777.358-.95.227s-.143-.425-.086-1.014l.015-.152c.015-.168.024-.25 0-.329-.024-.078-.078-.14-.186-.265l-.097-.114c-.377-.441-.566-.662-.5-.874s.343-.274.896-.399l.143-.033c.157-.035.236-.053.3-.101.063-.048.103-.12.184-.266zM9.75 8h-1.5c-1.06 0-1.59 0-1.92.33C6 8.659 6 9.189 6 10.25V17h6v-6.75c0-1.06 0-1.59-.33-1.92C11.342 8 10.811 8 9.75 8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M5.67 15.08c-.328-.33-.859-.33-1.92-.33s-1.59 0-1.92.33c-.33.329-.33.859-.33 1.92H6c0-1.06 0-1.59-.33-1.92m6.33-.33V17h4.5v-2.25c0-1.06 0-1.59-.33-1.92-.329-.33-.859-.33-1.92-.33s-1.59 0-1.92.33c-.33.329-.33.859-.33 1.92",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }